import { render, staticRenderFns } from "./listDispatch.vue?vue&type=template&id=bf0ddc8a&"
import script from "./listDispatch.vue?vue&type=script&lang=js&"
export * from "./listDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports